// The personas of Keycloak_Roles_and_Permissions.xlsx plus the platform admin:
// the only realm roles Keycloak holds (backend/src/config/rbacModel.js).
export const ROLE_KEYS = [
  'livebetter_facility_manager',
  'livebetter_energy_auditor',
  'livebetter_asset_manager',
  'livebetter_municipal_officer',
  'livebetter_aggregator',
  'livebetter_occupant',
  'livebetter_architect_engineer',
  'livebetter_sustainability_officer',
  'livebetter_esco_investor',
  'livebetter_energy_officer',
  'livebetter_utility_flexibility_manager',
  'system_admin',
];

export const roleLabels = {
  // Persona names of the BC x persona x service access model (the technical
  // role names of the first six predate it).
  livebetter_facility_manager: 'Building/Facility Manager',
  livebetter_energy_auditor: 'Auditor/Consultant',
  livebetter_asset_manager: 'Asset Manager',
  livebetter_municipal_officer: 'Local/Public Authorities',
  livebetter_aggregator: 'Aggregator',
  livebetter_occupant: 'Occupant/Tenant',
  livebetter_architect_engineer: 'Architect/Engineer',
  livebetter_sustainability_officer: 'Sustainability Officer',
  livebetter_esco_investor: 'ESCO/Investor',
  livebetter_energy_officer: 'Energy Officer',
  livebetter_utility_flexibility_manager: 'Utility/Flexibility Manager',
  system_admin: 'Platform Administrator',
};

export const roleKpiConfig = {
  livebetter_facility_manager: ['Energy savings %', 'EPC rating', 'Renovation status', 'DR flexibility score'],
  livebetter_energy_auditor: ['Inspection findings', 'EPC rating', 'Compliance progress', 'Audit readiness'],
  livebetter_asset_manager: ['Portfolio risk', 'Expected ROI', 'CO2 reduction', 'Renovation readiness'],
  livebetter_municipal_officer: ['District CO2 trend', 'Retrofit rate', 'Funding absorption', 'Compliance progress'],
  livebetter_aggregator: ['DR flexibility score', 'Peak shaving', 'M&V confidence', 'Grid responsiveness'],
  livebetter_occupant: ['Comfort index', 'Indoor air quality', 'Energy use', 'Cost savings'],
  livebetter_architect_engineer: ['Inspection findings', 'EPC rating', 'Renovation status', 'Compliance progress'],
  livebetter_sustainability_officer: ['CO2 reduction', 'EPC rating', 'Compliance progress', 'Renovation status'],
  livebetter_esco_investor: ['Portfolio risk', 'Expected ROI', 'CO2 reduction', 'Renovation readiness'],
  livebetter_energy_officer: ['Energy savings %', 'Indoor air quality', 'Inspection findings', 'Compliance progress'],
  livebetter_utility_flexibility_manager: ['DR flexibility score', 'Peak shaving', 'M&V confidence', 'Grid responsiveness'],
  system_admin: ['System uptime', 'Ingestion health', 'Security alerts', 'Active users'],
};

export const serviceCatalog = [
  { key: 's3.1', name: 'Performance', description: 'Building performance optimization and benchmarking.' },
  { key: 's3.2', name: 'Certification / EPC', description: 'Dynamic EPC estimation and compliance support.' },
  { key: 's3.3', name: 'Inspection', description: 'Automated quality and anomaly inspection workflows.' },
  { key: 's3.4', name: 'Renovation', description: 'Renovation pathway planning and sequencing.' },
  { key: 's3.5', name: 'Activation / DR', description: 'Demand-response activation and flexibility analytics.' },
];
